/*
 * @Author: 张印 hbzyin@163.com
 * @Date: 2023-08-09 15:32:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-08-28 10:00:04
 * @FilePath: /code/mall-fe/src/libs/drag.ts
 * @Description: 右侧悬浮窗拖拽函数
 *
 */
/**
 * 拖拽移动
 * @param  {elementObjct} bar 鼠标点击控制拖拽的元素
 * @param {elementObjct}  target 移动的元素
 */
export function startDrag(bar, target) {
  let params = {
    bottom: 0,
    currentY: 0,
    flag: false,
  };
  const docHeight = document.documentElement.clientHeight;
  bar.onmousedown = function (e) {
    // 按下时初始化params
    params = {
      bottom: docHeight - target.offsetTop - target.offsetHeight,
      currentY: e.clientY,
      flag: true,
    };
    document.documentElement.style.cursor = 'grabbing';
    bar.style.cursor = 'grabbing';
    document.onmousemove = function (event) {
      if (params.flag) {
        // 差异距离
        const disY = event.clientY - params.currentY;
        // 最终移动位置
        let zBottom = params.bottom - disY;
        // 限制Y轴范围
        if (zBottom <= 0) {
          zBottom = 0;
        }
        if (zBottom >= docHeight - target.offsetHeight - 40) {
          zBottom = docHeight - target.offsetHeight - 40;
        }

        // 执行移动
        target.style.bottom = zBottom + 'px';
      }
    };
    document.onmouseup = function () {
      params.flag = false;
      document.onmousemove = null;
      document.onmouseup = null;
      document.documentElement.style.cursor = 'default';
      bar.style.cursor = 'grab';
    };
  };
}
